import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ReactNode, useEffect } from "react";
import styled from "styled-components";
import { colors } from "src/styles/theme";
import Button from "../Button";
// import { FaArrowLeft } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa6";

// import Button from "../Button";
// import { IoArrowBack } from "react-icons/io5";

const layoutObj: {
  [key in string]: {
    backBtn?: boolean;
    title?: ReactNode | string;
    backUrl?: string;
    headerButton?: {
      text: string;
      onClick: () => void;
    };
  };
} = {
  "/year-booking/group-register": {
    backBtn: true,
    title: <div className="hd">단체 정보 등록</div>,
  },
  "/year-booking/group-join": {
    backBtn: true,
    title: <div className="hd">단체 참여</div>,
  },
  "/year-booking/booking-register": {
    backBtn: true,
    title: (
      <div className="hd">골프장 예약</div>
      // <div className="group-regi-header-content">
      //   <p className="left">1. 단체 정보 등록</p>
      //   <p className="right active">{" > "}2.연간 부킹 신청</p>
      // </div>
    ),
    backUrl: "/year-booking",
  },
  "/year-booking/group-manage": {
    backBtn: true,
    title: <div className="hd">단체정보 관리</div>,
  },
  "/year-booking/group-members": {
    backBtn: true,
    title: <div className="hd">멤버 관리</div>,
  },
  "/year-booking/group-members/register-all": {
    backBtn: true,
    title: <div className="hd">멤버 일괄 등록</div>,
  },
  "/year-booking/group-members/list": {
    backBtn: true,
    title: "멤버 리스트",
    backUrl: "/year-booking",
    headerButton: {
      text: "조편성",
      onClick: () => {}, // Header 컴포넌트에서 실제 함수로 교체됨
    },
  },
  "/year-booking/team-register": {
    backBtn: true,
    title: "조 편성",
    backUrl: "/year-booking",
    headerButton: {
      text: "멤버 등록",
      onClick: () => {}, // Header 컴포넌트에서 실제 함수로 교체됨
    },
  },
  "/year-booking/deposit": {
    backBtn: true,
    title: <div className="hd">보증금</div>,
  },
  "/year-booking/booking-register/result": {
    backBtn: true,
    title: <div className="hd">연단체 신청내용</div>,
  },
  "/year-booking/condition": {
    backBtn: true,
    title: <div className="hd">연단체 협약내용</div>,
  },
  "/year-booking/proposals": {
    backBtn: true,
    title: <div className="hd">희망 골프장 선택</div>,
  },
  "/year-booking/faq": {
    backBtn: true,
    title: <div className="hd">자주묻는질문</div>,
  },
  "/year-booking/roundPayment": {
    backBtn: true,
    title: <div className="hd">수수료 납부</div>,
  },
  "/kgController": {
    backBtn: true,
    title: <div className="hd">수수료 납부</div>,
  },
  "/event-booking/booking-register": {
    backBtn: true,
    title: <div className="hd">골프장 선택</div>,
  },
  "/event-booking/application-info": {
    backBtn: true,
    title: <div className="hd">신청정보</div>,
  },
  "/event-booking/round-date": {
    backBtn: true,
    title: <div className="hd">라운드일자</div>,
  },
  "/event-booking/round-options": {
    backBtn: true,
    title: <div className="hd">라운드 옵션</div>,
  },
  "/event-booking/payment-options": {
    backBtn: true,
    title: <div className="hd">결제옵션</div>,
  },
  "/event-booking/faq": {
    backBtn: true,
    title: <div className="hd">자주묻는질문</div>,
  },
  "/event-booking/register-result": {
    backBtn: true,
    title: <div className="hd">신청내역</div>,
  },
  "/event-booking/member-list": {
    backBtn: true,
    title: <div className="hd">멤버등록</div>,
  },
  "/event-booking/proposals": {
    backBtn: true,
    title: <div className="hd">희망 골프장 선택</div>,
  },
  "/event-booking/condition": {
    backBtn: true,
    title: <div className="hd">월단체 협약내용</div>,
  },
  "/event-booking/team-register": {
    backBtn: true,
    title: <div className="hd">조 편성</div>,
  },
  "/event-booking/payment": {
    backBtn: true,
    title: <div className="hd">수수료 & 보증금</div>,
  },
  "/year-booking/lan": {
    backBtn: true,
    title: <div className="hd">연단체</div>,
  },
  "/year-booking/complete": {
    backBtn: true,
    title: <div className="hd">연단체 신청 완료</div>,
    // backUrl: "/year-booking/booking-register",
  },
  "/year-booking/cancellation-policy": {
    backBtn: true,
    title: <div className="hd">골프장 취소 위약 규정</div>,
  },
  "/year-booking/privacy-consent": {
    backBtn: true,
    title: <div className="hd">개인정보 제3자 제공 동의</div>,
  },
};

export default function SimpleLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Header />
      <OutletCover className="page-default">
        <Outlet />
      </OutletCover>
    </>
  );
}

const Header = (props?: { backBtn?: boolean; title?: string }) => {
  const navigete = useNavigate();
  const lc = useLocation();

  const compData = layoutObj[lc.pathname as keyof typeof layoutObj];
  const Comp: any = () => {
    return compData?.title || "page-title-simple";
  };

  const handleHeaderButtonClick = () => {
    if (lc.pathname === "/year-booking/group-members/list") {
      navigete("/year-booking/team-register");
    } else if (lc.pathname === "/year-booking/team-register") {
      navigete("/year-booking/group-members/list");
    }
  };

  return (
    <StyledHeader className="pd-2 header-height">
      {compData?.backBtn && compData?.backUrl && (
        <Button onClick={() => navigete(compData?.backUrl as string)}>
          <FaArrowLeft size={"20px"} fontWeight={"normal"} />
        </Button>
      )}
      {compData?.backBtn && !compData?.backUrl && (
        <Button onClick={() => navigete(-1)}>
          <FaArrowLeft size={"20px"} fontWeight={"normal"} />
        </Button>
      )}
      <h2>
        {compData?.headerButton ? (
          <div className="header-content">
            <div className="hd">{compData.title}</div>
            <button className="header-button" onClick={handleHeaderButtonClick}>
              {compData.headerButton.text}
            </button>
          </div>
        ) : (
          <Comp />
        )}
      </h2>
      <span></span>
    </StyledHeader>
  );
};
//border: 10px solid red;
const OutletCover = styled.div`
  overflow: auto;
`;
const StyledHeader = styled.header`
  background-color: #fff;
  border-bottom: 1px solid ${colors.gray.second};
  width: 100%;
  display: flex;
  align-items: center;
  > :first-child,
  > :last-child {
    min-width: 30px;
  }
  h2 {
    font-size: 18px;

    flex: 1;
  }
  .group-regi-header-content {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: 5px;
    .left {
    }
    .right {
    }
    :not(.active) {
      color: ${colors.gray.second};
    }
  }
  .header-content {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 6px 12px;
    .hd {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 18px;
      font-weight: bold;
    }
    .header-button {
      position: absolute;
      right: 20px;
      display: flex;
      padding: 6px 12px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 6px;
      border: none;
      background: #007bff;
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      cursor: pointer;
      &:hover {
        background: #0056b3;
      }
      &:focus {
        outline: none;
      }
    }
  }
`;
